import { render } from "./settle-apply.vue?vue&type=template&id=6f0a72f7&scoped=true"
import script from "./settle-apply.vue?vue&type=script&lang=js"
export * from "./settle-apply.vue?vue&type=script&lang=js"

import "./settle-apply.vue?vue&type=style&index=0&id=6f0a72f7&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0a72f7"]])

export default __exports__